import Index from '@/views/imageRequests/Index'

export default [
  {
    path: ':clientId/imageRequests',
    name: 'imageRequests.index',
    component: Index
  }
]
